import React from "react";
import {Link, useLocation} from "react-router-dom"

function AccountButton(props) {

    const location = useLocation().pathname
    const account = props.account

    return (
        <Link id={location.startsWith("/@" + account) ? "accountbuttonactive" : "accountbutton"} to={account ? "/@" + account + "/profile" : "/login"}>{account ? ":)" : ":("}</Link>
    )
}

export default AccountButton
